// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-module--modal--3BPw_","overlay":"modal-module--overlay--2nP4M","trigger":"modal-module--trigger--BFLIC","close":"modal-module--close--1refL"};